import { motion } from "framer-motion";
import { HERO } from "../../data/content";
import { scrollToId } from "../../lib/scroll";

const PORTRAIT = "/hero-main.png";
const ease = [0.19, 1, 0.22, 1];
const up = (d = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.85, delay: d, ease },
});

const STATS = [
  ["19", "Books published"],
  ["4×", "TEDx speaker"],
  ["20+", "Technologies"],
];

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative border-b border-[var(--line)] bg-[#f4f2ec]"
    >
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 px-6 pb-16 pt-32 md:px-10 lg:grid-cols-12 lg:pb-24 lg:pt-40">
        {/* Left column */}
        <div className="lg:col-span-7 lg:border-r lg:border-[var(--line)] lg:pr-14">
          <motion.h1
            {...up(0.15)}
            className="font-display text-6xl font-medium leading-[0.92] tracking-tight text-[#1c2b4a] md:text-7xl lg:text-8xl"
          >
            Adonica
            <br />
            Shaw
          </motion.h1>

          <motion.p
            {...up(0.28)}
            className="mt-6 font-display text-2xl italic text-[#9c7a33] md:text-3xl"
          >
            Advocate. Educator. Author. Founder.
          </motion.p>

          <motion.p
            {...up(0.38)}
            className="mt-7 max-w-xl text-base leading-relaxed text-[#475569] md:text-lg"
          >
            {HERO.intro}
          </motion.p>

          <motion.div {...up(0.48)} className="mt-9 flex flex-wrap gap-4">
            <button
              data-testid="hero-keynote-cta"
              onClick={() => scrollToId("#booking")}
              className="rounded-full bg-[#9c7a33] px-7 py-3.5 text-sm uppercase tracking-[0.12em] text-[#faf8f5] transition-colors duration-300 hover:bg-[#7e6128]"
            >
              Request a Keynote
            </button>
            <button
              data-testid="hero-advocacy-cta"
              onClick={() => scrollToId("#advocacy")}
              className="rounded-full border border-[#1c2b4a]/25 px-7 py-3.5 text-sm uppercase tracking-[0.12em] text-[#1c2b4a] transition-colors duration-300 hover:border-[#9c7a33] hover:text-[#9c7a33]"
            >
              Explore Advocacy
            </button>
          </motion.div>

          <motion.dl
            {...up(0.58)}
            className="mt-12 grid max-w-lg grid-cols-3 gap-6 border-t border-[var(--line)] pt-8"
          >
            {STATS.map(([n, l]) => (
              <div key={l}>
                <dt className="font-mono text-3xl text-[#1c2b4a] md:text-4xl">{n}</dt>
                <dd className="mt-1 text-[11px] uppercase tracking-[0.12em] text-[#475569]">
                  {l}
                </dd>
              </div>
            ))}
          </motion.dl>
        </div>

        {/* Right column — framed portrait */}
        <motion.div {...up(0.3)} className="mt-14 lg:col-span-5 lg:mt-0 lg:pl-14">
          <div className="relative">
            <div className="absolute -right-3 -top-3 hidden h-full w-full rounded-sm border border-[#9c7a33]/45 lg:block" />
            <div className="relative overflow-hidden rounded-sm border border-[var(--line)] bg-white p-2 shadow-[0_30px_60px_-30px_rgba(15,23,42,0.35)]">
              <img
                src={PORTRAIT}
                alt="Adonica Shaw"
                className="h-[440px] w-full rounded-sm object-cover object-[center_12%] md:h-[600px]"
              />
            </div>
            <div className="relative z-10 -mt-12 ml-4 max-w-xs rounded-sm border border-[var(--line)] bg-white/95 p-5 backdrop-blur">
              <p className="font-display text-xl italic leading-snug text-[#1c2b4a]">
                “Believe women before you treat them.”
              </p>
              <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-[#9c7a33]">
                — Adonica Shaw
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
